import { Spinner, Wrap } from '@chakra-ui/react'
import type { FC } from 'react'

import File from './file'

import type { MinimalDomainObject } from '@app/types'
import type { AiAssistantFile } from '@graphql/types'

interface Props {
  loading?: boolean
  files?: MinimalDomainObject<AiAssistantFile>[]
}

const FoldersSectionContent: FC<Props> = ({ loading = false, files = [] }) => {
  if (loading) {
    return <Spinner />
  }

  if (!files?.length) {
    return null
  }

  return (
    <Wrap gap={3}>
      {files.map((file) => (
        <File key={file.id} file={file} />
      ))}
    </Wrap>
  )
}

export default FoldersSectionContent
